const AUTH_KEY = 'momlingo_auth';

export function isAuthenticated(): boolean {
  return document.cookie.includes('momlingo_session=') || localStorage.getItem(AUTH_KEY) === 'true';
}

export async function login(passcode: string): Promise<boolean> {
  try {
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ passcode }),
    });
    if (res.ok) {
      localStorage.setItem(AUTH_KEY, 'true');
      return true;
    }
    return false;
  } catch {
    // Offline fallback: check against cached auth
    return localStorage.getItem(AUTH_KEY) === 'true';
  }
}

export function logout(): void {
  localStorage.removeItem(AUTH_KEY);
  document.cookie = 'momlingo_session=; Max-Age=0; path=/';
}
